<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="7"> 
				<el-input clearable placeholder="请输入商家名称" v-model="searchInfo.name">
					<template slot="prepend">商家名称</template>
				</el-input>
			</el-col>
			<el-col :span="9"> 
				<el-button type="primary" @click="searchBusinesss" icon="el-icon-search">搜索</el-button>
				<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="addBusinesss">新增</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="businesssList"  style="width: 100%"  height="700">
			    <el-table-column fixed="left" prop="name" label="名称" width="150" align="center"></el-table-column>
			    <el-table-column prop="legalperson" label="法人姓名" width="120" align="center"></el-table-column>
			    <el-table-column prop="contactperson" label="联系人"  width="120" align="center"></el-table-column>
			    <el-table-column prop="phone" label="联系电话" width="120" align="center"></el-table-column>
			    <el-table-column prop="jointime" label="入驻时间" align="center"></el-table-column>
				<el-table-column prop="statename" label="状态" align="center"></el-table-column>
				<el-table-column prop="pic" label="营业执照" width="120" align="center">
					<template slot-scope="scope">
						<el-image style="width: 60px; height: 60px;border-radius: 10px;" :src="scope.row.businesslicense" ></el-image>
					</template>
				</el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goBusinessDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Business">详情</i>
						</a>
						<a v-show="scope.row.state == 'stop'" @click="ChangeState(scope.$index, scope.row)" title="启用" style="cursor:pointer;margin-left: 10px;color: #E6A23C;">
							<i class="el-icon-bottom">启用</i>
						</a>
						<a v-show="scope.row.state == 'normal'" @click="ChangeState(scope.$index, scope.row)" title="停用" style="cursor:pointer;margin-left: 10px;color: #67C23A;">
							<i class="el-icon-top">停用</i>
						</a>
						<a v-show="scope.row.state == 'stop'" @click="deleteBusinessed(scope.$index, scope.row)" title="删除商家" style="cursor:pointer;margin-left: 10px;color: #F56C6C;">
							<i class="el-icon-delete">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="businesssTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<BusinesssDetail @needRefrash="needRefrash" :select_id="selectID"></BusinesssDetail>
		</el-dialog>
	</div>
</template>

<script>
	import dayjs from 'dayjs'
	import {nfsprefix, baseUrl } from '/static/baseUrl.js'
	import {queryBusinessLists,ChangeBusinessState,deleteBusiness } from '/static/apiUrl.js'
	import BusinesssDetail from './businessdetail'
	export default {
		name : 'businesssList',
		data() {
			return {
				detailShow: false,
				editok : false,
				detailTitle: '商家详情',
				selectID: '',	
				searchInfo:{
					name : '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				businesssTotal : 0,
				businesssList : [],				
			}
		},
		mounted() {
			this.initData()
			this.queryBusinesss()
		},
		components: {
			BusinesssDetail,
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryBusinesss()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryBusinesss()
			},
			ChangeState(idx, row){
				console.log(idx, row)
				let name = ""
				let new_state = ""
				if (row.state == "normal") {
					name = "停用"
					new_state = "stop"
				} else { 
					name = "启用"
					new_state = "normal"
				}
				this.$confirm('确定将 ' + row.name + ' ' + name + '?', name, {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					ChangeBusinessState({
						state: new_state,
						id: row.id
					}).then(res => {
						console.log(res)
						if (0 == res.code) {
							row.statename = name
							row.state = new_state
							this.$message({
								type: 'success',
								message: name + '成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			deleteBusinessed(idx,row){
				console.log(idx,row)
				this.$confirm('确定将 '+row.name+' 删除?', '商家删除', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let fids = [row.id]
					deleteBusiness({
						ids : fids
					}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.businesssList.splice(idx,1)
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			initData() {
			},
			searchBusinesss(){
				this.param.page = 1
				this.businesssList = []
				this.queryBusinesss()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.param.page = 1
				this.queryBusinesss()
			},
			queryBusinesss(){
				this.businesssList = []
				queryBusinessLists({
					name : this.searchInfo.name,
					offset : (this.param.page - 1) * this.param.pagenum,
					limit : this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.businesssTotal = res.data.total
						res.data.data.forEach((business) => {
							this.businesssList.push({
								id: business.entry_business_id,
								name: business.entry_business_name,
								legalperson: business.entry_business_legalperson,
								phone: business.entry_business_phone,
								contactperson: business.entry_business_contactperson,
								jointime: dayjs(business.entry_business_jointime).format('YYYY-MM-DD'),
								state: business.entry_business_state,
								statename: business.entry_business_state == 'normal' ? '启用' : '停用',
								businesslicense: baseUrl + nfsprefix + business.entry_business_businesslicense,
							})
						})
					}
				})
			},
			goBusinessDetail(idx,row){
				this.detailTitle = '商家详情'
				console.log(idx,row)
				this.selectID = row.id
				this.detailShow = true
			},
			addBusinesss(){
				this.detailTitle = "新增商家"
				this.selectID = ''
				this.detailShow = true
			},
			needRefrash(val,isshow){
				console.log(val, isshow)
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				console.log('ddd')
				if(this.editok){
					this.queryBusinesss()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>